function isNil(x) {
    return x == null;
}

export { isNil };
